export const ACTIVE_CARD_REQUEST = "ACTIVE_CARD_REQUEST";
export const ACTIVE_CARD_SUCCESS = "ACTIVE_CARD_SUCCESS";
export const ACTIVE_CARD_FAILURE = "ACTIVE_CARD_FAILURE";
export const ACTIVE_CARD_CLEAN = "ACTIVE_CARD_CLEAN";

export const CHECK_CARD_REQUEST = "CHECK_CARD_REQUEST";
export const CHECK_CARD_SUCCESS = "CHECK_CARD_SUCCESS";
export const CHECK_CARD_FAILURE = "CHECK_CARD_FAILURE";
export const CHECK_CARD_CLEAN = "CHECK_CARD_CLEAN";
